export class VibrationsChartHeader {

  equipementId: string;
  equipmentType: number;
  fileName: string;
  timestamp: Date;
  dateOfCalibration: Date;
  recordLength: number;
  recordType: string;
  preTrigger: number
  samplingPeriod: number;
  numberOfChannels: number;
  note1: string;
  note2: string;
  note3: string;
  siteId: number;
  tirId: number;
  controlPointId: number;
  coordinatesFrom: number;
  longitude: string;
  latitude: string;

}

